/*jshint esversion: 6 */

import WidgetShortList from "../widgets/WidgetShortList";
import GenericSearch from '../forms/search/GenericSearch.js';
import CategorySearch from '../forms/search/CategorySearch.js';
import FilterSearch from '../forms/search/FilterSearch.js';
import WidgetELearningPercentageComplete from '../widgets/WidgetELearningPercentageComplete.js';
import WidgetELearningModuleCompletionButton from "../widgets/WidgetELearningModuleCompletionButton";
import dialogPolyfill from 'dialog-polyfill/dialog-polyfill'
import Ajax from "../common/Ajax";
import * as Utils from "../common/Utils";
import foreachPolyfill from "../common/polyfill-foreach";

GenericSearch();
FilterSearch();
CategorySearch({
    locale: LOCALE,
    env: ENV,
});
WidgetShortList({
    selector: 'btn-shortlist',
    locale: LOCALE,
    env: ENV,
    route: "/widget/shortlist/%type%/%id%"
});

const modals = document.querySelectorAll('dialog');
if(modals) {
    modals.forEach(function (value, i){
        dialogPolyfill.registerDialog(value);
    });
}

function runStatusCheck(moduleID)
{
    if(moduleID ==='') {
        return false;
    }

    let moduleCompleteBtn = WidgetELearningModuleCompletionButton({
        locale: LOCALE,
        env: ENV,
        route: "/widget/elearning/module/%id%/percentage-complete",
        btnSelector: '#elearning-proceed-completion-btn',
        completionLimit: fe_config.completion_limit
    });

    moduleCompleteBtn.getModuleStats(moduleID);

    moduleCompleteBtn.automateStatusCheck(moduleID, 60000);
}

if (IS_LOGGED_IN) {
    WidgetELearningPercentageComplete({
        selector: 'e-learning-percentage-complete',
        locale: LOCALE,
        env: ENV,
        route: "/widget/elearning/%type%/%id%/percentage-complete",
        completionLimit: fe_config.completion_limit
    });

    let moduleContainer = document.querySelector('#e-learning-module-container');

    if(moduleContainer) {
        let moduleID = moduleContainer.getAttribute('data-id');
        runStatusCheck(moduleID);

    }


}
let openDialog = function () {
    getDialog().show();
};

Window.closeDialog = function (e) {
    let thisDialog = e.parentElement;
    thisDialog.close();
    let thisBackgroundCover = document.querySelector('#background-cover');
    if (thisBackgroundCover) {
        thisBackgroundCover.classList.toggle('hidden');
    }
};

let getDialog = function () {
    return document.querySelector('dialog');
};

let unhide = function (element) {
    element.classList.toggle('hidden');
}

let loginOpenBtn = document.querySelector('#login-portal-open-btn');
if (loginOpenBtn) {
    loginOpenBtn.onclick = function () {
        console.log('open login form');
        openDialog();
        // ratingForm.buildForm(id);
    };
}

let backgroundCover = document.querySelector('#background-cover');

document.querySelectorAll('.dialog-start').forEach(item => {
    item.addEventListener('click', event => {
        event.preventDefault();
        openDialog();
        if (backgroundCover) {
            unhide(backgroundCover);
        }
    });
});

document.querySelectorAll('.dialog-start-project').forEach(item => {
    item.addEventListener('click', event => {
        event.preventDefault();

        let project = event.target.getAttribute('data-id');

        let modal = document.querySelector(`dialog[data-id='${project}']`);
        if (modal) {
            modal.show();
        }

        if (backgroundCover) {
            unhide(backgroundCover);
        }
    });
});

function createRoute (type, identifier) {
    return Utils.generateRouteFromPattern({
        pattern : {
            '%action%' : type,
            '%identifier%': identifier
        },
        route : "/widget/user/group/%action%/%identifier%",
        env : ENV,
        locale: LOCALE
    });
}

let joinElement = document.querySelector('input.group-join');
if (joinElement) {
    joinElement.addEventListener('change', event => {

        let input = event.target;
        let route = '';
        let groupIdentifier = joinElement.getAttribute('data-id');

        let successLeave = function(response){
            console.log(response);
            let message = `You have left the group`;
            let joinDialogMessage = document.querySelector('dialog.group.join .message');
            joinDialogMessage.textContent = response.message;
            let joinActivator = document.querySelector('.dialog-start-project');
            joinActivator.classList.remove('joined')
        };
        let successJoin = function(response){
            console.log(response);
            let message = `You have joined the group`;
            let joinDialogMessage = document.querySelector('dialog.group.join .message');
            joinDialogMessage.textContent = response.message;
            let joinActivator = document.querySelector('.dialog-start-project');
            joinActivator.classList.add('joined')
        };


        let error = function(response){
            console.log('ajax error:');
            console.log(response);
            alert('There was an error. Please reload the page and try again.');
        };

        if (input.checked) {
            route = createRoute('join', groupIdentifier);
            Ajax.getRequest(route, successJoin, error);
        } else {
            route = createRoute('leave', groupIdentifier);
            Ajax.getRequest(route, successLeave, error);
        }


    });
}


